import { render, staticRenderFns } from "./RightMenu.vue?vue&type=template&id=c6c7c4f4&lang=html&"
import script from "./RightMenu.vue?vue&type=script&lang=js&"
export * from "./RightMenu.vue?vue&type=script&lang=js&"
import style0 from "./RightMenu.vue?vue&type=style&index=0&id=c6c7c4f4&prod&lang=css&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports